import React, { useState, useEffect } from "react";
import { FaPlus } from "react-icons/fa";
import axios from "axios";
import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import config from "../../config";

const UNIT_CATEGORIES = ["Weight", "Temperature", "Water"];
const UNIT_OPTIONS = {
  Weight: ["kg", "gm"],
  Temperature: ["°C", "°F"],
  Water: ["ml", "litre"],
};
const categories = [
  "General",
  "Medical",
  "Weight",
  "Temperature",
  "Water",
  "Food",
  "Potty",
  "Grooming",
  "Behaviour",
  "Other",
];

export const Diarydrawer = ({
  open,
  onClose,
  pets = [],
  diaryToEdit = null,
  onSaveSuccess,
}) => {
  const token = localStorage.getItem("token");
  const decoded = token ? jwtDecode(token) : null;
  const client_id = decoded?.data?.customer_data?.id;

  const initialState = {
    selectedCategory: "General",
    activePet: pets[0]?._id || null,
    title: "",
    notes: "",
    unitValue: "",
    unitType: "",
    date: new Date().toISOString().slice(0, 10),
    time: new Date().toTimeString().slice(0, 5),
    type: "",
    mediaFiles: [],
    docFiles: [],
  };

  const [form, setForm] = useState(initialState);
  const [originalForm, setOriginalForm] = useState(null);

  useEffect(() => {
    if (pets.length && !form.activePet) {
      setForm((prev) => ({ ...prev, activePet: pets[0]._id }));
    }
  }, [pets]);

  useEffect(() => {
  if (diaryToEdit) {
    let parsedValue = "";
    let parsedUnit = "";

    if (
      UNIT_CATEGORIES.includes(diaryToEdit.category) &&
      diaryToEdit.notes
    ) {
      const parts = diaryToEdit.notes.split(" ");
      parsedValue = parts[0] || "";
      parsedUnit = parts.slice(1).join(" ") || "";
    }

    const editForm = {
      selectedCategory: diaryToEdit.category || "General",
      activePet: diaryToEdit.petId?._id || diaryToEdit.petId || null,
      title: diaryToEdit.title || "",
      notes: diaryToEdit.notes || "",
      unitValue: parsedValue,
      unitType: parsedUnit,
      date: diaryToEdit.date?.slice(0, 10) || "",
      time: diaryToEdit.time || "",
      type: diaryToEdit.visibility || "",
    };

    setForm((prev) => ({
      ...prev,
      ...editForm,
      mediaFiles: diaryToEdit.media || [],
      docFiles: diaryToEdit.documents || [],
    }));

    setOriginalForm(editForm);  

  } else {      
    setForm(initialState);
    setOriginalForm(null); 
  }
}, [diaryToEdit]);


  if (!open) return null;

  

  // ===================== UPLOAD HELPERS =====================
  const uploadDocument = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("module", "Diary");
    formData.append("docType", "document");
    formData.append("customerId", localStorage.getItem("customerId"));

    const res = await axios.post(
      `${config.API_BASE_URL}/upload/fileuploadcustomer`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return {
      url: res.data.data.s3Url,
      key: res.data.data.s3Key,
      type: "document",
      name: file.name,
    };
  };

  const uploadMedia = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("module", "Diary");
    formData.append("docType", "media");
    formData.append("customerId", localStorage.getItem("customerId"));

    const res = await axios.post(
      `${config.API_BASE_URL}/upload/fileuploadcustomer`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return {
      url: res.data.data.s3Url,
      key: res.data.data.s3Key,
      type: file.type.startsWith("video") ? "video" : "image",
      name: file.name,
    };
  };

  const handleMediaChange = async (e) => {
    const files = Array.from(e.target.files);
    for (const file of files) {
      const uploadedMedia = await uploadMedia(file);
      setForm((prev) => ({
        ...prev,
        mediaFiles: [...prev.mediaFiles, uploadedMedia],
      }));
    }
    toast.success("Media uploaded");
  };

  const handleDocChange = async (e) => {
    const files = Array.from(e.target.files);
    for (const file of files) {
      const uploadedDoc = await uploadDocument(file);
      setForm((prev) => ({
        ...prev,
        docFiles: [...prev.docFiles, uploadedDoc],
      }));
    }
    toast.success("Documents uploaded");
  };

   const isChanged = diaryToEdit
  ? JSON.stringify({
      selectedCategory: form.selectedCategory,
      activePet: form.activePet,
      title: form.title,
      notes: form.notes,
      unitValue: form.unitValue,
      unitType: form.unitType,
      date: form.date,
      time: form.time,
      type: form.type,
    }) !== JSON.stringify(originalForm)
  : true; 

  const isSaveDisabled = diaryToEdit
  ? !isChanged
  : UNIT_CATEGORIES.includes(form.selectedCategory)
    ? !form.unitValue || !form.unitType
    : !form.title.trim() || !form.notes.trim();


  const handleSave = async () => {
    console.log("handleSave triggered");
    const isUnitCategory = UNIT_CATEGORIES.includes(form.selectedCategory);
    if (!form.title?.trim()) {
      toast.error("Title field is required");
      return;
    }
    if (isUnitCategory) {
      if (!form.unitValue || !form.unitType) {
        toast.error("Please enter value and unit");
        return;
      }
    } else {
      if (!form.notes?.trim()) {
        toast.error("Notes field is required");
        return;
      }
    }
    const selectedPet = pets.find((p) => p._id === form.activePet);
   // const isUnitCategory = UNIT_CATEGORIES.includes(form.selectedCategory);

    const payload = {
      petId: selectedPet?._id || null,
      petName: selectedPet?.name || "",
      customerId: client_id,
      category: form.selectedCategory || "General",
      title: form.title,
      notes: isUnitCategory ? `${form.unitValue} ${form.unitType}` : form.notes,
      //notes: form.notes || `${form.unitValue} ${form.unitType}`,
      unitValue: isUnitCategory ? form.unitValue : null,
      unitType: isUnitCategory ? form.unitType : null,
      date: form.date,
      time: form.time,
      visibility: form.type,
      media: form.mediaFiles,
      documents: form.docFiles,
    };

    console.log("Payload being sent:", payload);
      try {
      if (diaryToEdit?._id) {
        // ✅ UPDATE MODE
        await axios.put(
          `${config.API_BASE_URL}/customer/updateDiary/${diaryToEdit._id}`,
          payload
        );
        toast.success("Diary updated successfully!");
      } else {
        // ✅ ADD MODE
        await axios.post(
          `${config.API_BASE_URL}/customer/addDairy`,
          payload
        );
        toast.success("Diary entry saved successfully!");
      }

      if (onSaveSuccess) {
        await onSaveSuccess();   // wait for refetch
      }

      onClose();
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to save diary entry."
      );
    }
  };


  return (
    <div className="fixed inset-0 z-50 flex justify-end">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Responsive Drawer */}
      <div
        className="relative w-full max-w-full sm:max-w-2xl lg:max-w-3xl h-full bg-white shadow-2xl overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sticky top-0 bg-white border-b border-gray-200 z-10">
          <div className="flex items-center justify-between p-5 sm:p-7">
            <h2 className="text-xl sm:text-2xl font-bold text-blue-950">
              Add Diary Entry
            </h2>
            <button
              onClick={onClose}
              className="w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center text-2xl text-gray-600 transition"
            >
              ✕
            </button>
          </div>
        </div>

        <div className="p-5 sm:p-8 space-y-7">
          {/* Categories - Dropdown on mobile/tablet, Buttons on large */}
          <div>
            <h3 className="text-lg font-semibold text-blue-950 mb-4">
              Category
            </h3>

            {/* Mobile & Tablet: Dropdown */}
            <div className="lg:hidden">
              <select
                value={form.selectedCategory}
                onChange={(e) => {
                  if (diaryToEdit) return;
                  setForm({
                    ...initialState,
                    selectedCategory: e.target.value,
                    activePet: form.activePet,
                    mediaFiles: [],
                  docFiles: [],
                  });
                }}
                className="w-full px-5 py-4 rounded-xl border border-gray-300 bg-white focus:ring-4 focus:ring-blue-100 outline-none text-base"
              >
                {categories.map((cat) => (
                  <option key={cat} value={cat}>
                    {cat}
                  </option>
                ))}
              </select>
            </div>

            {/* Large Screen: Buttons (original) */}
            <div className="hidden lg:flex flex-wrap gap-3">
              {categories.map((cat) => (
                <button
                  key={cat}
                  onClick={() => {
                    if (diaryToEdit) return;
                    setForm({
                      ...initialState,
                      selectedCategory: cat,
                      activePet: form.activePet,
                      mediaFiles: [],
                    docFiles: [],
                    });
                  }}
                  className={`px-6 py-3 rounded-full text-sm font-semibold transition shadow-sm ${
                    form.selectedCategory === cat
                      ? "bg-blue-950 text-white"
                      : "bg-gray-100 text-blue-900 hover:bg-gray-200"
                  }`}
                >
                  {cat}
                </button>
              ))}
            </div>
          </div>

          {/* Pet Selection */}
          {pets.length > 0 && (
            <div>
              <label className="block text-lg font-semibold text-blue-950 mb-4">
                Who is this for?
              </label>
              <div className="flex gap-5 overflow-x-auto p-3 scrollbar-thin snap-x snap-mandatory">
                {pets.map((pet) => {
                  const petImage = pet.profile_photo
                    ? pet.profile_photo.startsWith("http")
                      ? pet.profile_photo
                      : `${config.S3_BASE_URL || process.env.REACT_APP_S3_BASE_URL}/${pet.profile_photo}`
                    : null;

                  return (
                    <div
                      key={pet._id}
                      onClick={() => {
                        if (diaryToEdit) return;
                        setForm({
                          ...initialState,
                          activePet: pet._id,
                          selectedCategory: form.selectedCategory,
                          mediaFiles: [],
                        docFiles: [],
                        });
                      }}
                      className="flex flex-col items-center cursor-pointer snap-start flex-shrink-0"
                    >
                      <div
                        className={`w-20 h-20 sm:w-24 sm:h-24 rounded-full border-4 overflow-hidden shadow-lg transition-all ${
                          form.activePet === pet._id
                            ? "border-orange-500 scale-110"
                            : "border-gray-300"
                        }`}
                      >
                        {petImage ? (
                          <img
                            src={petImage}
                            alt={pet.name}
                            className="w-full h-full object-cover"
                          />
                        ) : (
                          <div className="w-full h-full bg-gray-200 flex items-center justify-center">
                            <span className="text-3xl font-bold text-gray-500 uppercase">
                              {pet.name?.charAt(0)}
                            </span>
                          </div>
                        )}
                      </div>
                      <span
                        className={`mt-3 text-sm sm:text-base font-semibold ${
                          form.activePet === pet._id
                            ? "text-orange-600"
                            : "text-gray-700"
                        }`}
                      >
                        {pet.name}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* Title */}
          <div>
            <label className="block text-sm font-semibold text-blue-950 mb-2">
              Title <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Add a title..."
              value={form.title}
              onChange={(e) =>
                setForm((prev) => ({ ...prev, title: e.target.value }))
              }
              className="w-full rounded-xl border border-gray-300 px-5 py-4 text-base focus:ring-4 focus:ring-blue-100 outline-none transition"
            />
          </div>

          {/* Notes or Unit Input */}
          {UNIT_CATEGORIES.includes(form.selectedCategory) ? (
            <div>
              <label className="block text-sm font-semibold text-blue-950 mb-2">
                {form.selectedCategory} Value
              </label>
              <div className="flex flex-col sm:flex-row gap-4">
                <input
                  type="number"
                  placeholder={`Enter ${form.selectedCategory.toLowerCase()}`}
                  value={form.unitValue}
                  onKeyDown={(e) => {
                      if (["-", "+", "e", "E"].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow empty (so user can delete)
                      if (value === "") {
                        setForm((prev) => ({ ...prev, unitValue: "" }));
                        return;
                      }
                      const numericValue = Number(value);
                      // Allow only positive numbers greater than 0
                      if (!isNaN(numericValue) && numericValue > 0) {
                        setForm((prev) => ({ ...prev, unitValue: value }));
                      }
                    }}
                  className="flex-1 rounded-xl border border-gray-300 px-5 py-4 focus:ring-4 focus:ring-blue-100 outline-none"
                />
                <select
                    value={form.unitType}
                    onChange={(e) =>
                      setForm((prev) => ({ ...prev, unitType: e.target.value }))
                    }
                    className={`rounded-xl border px-5 py-4 focus:ring-4 outline-none ${
                      !form.unitType && UNIT_CATEGORIES.includes(form.selectedCategory)
                        ? "border-red-400"
                        : "border-gray-300"
                    }`}
                  >
                  <option value="">Select unit</option>
                  {UNIT_OPTIONS[form.selectedCategory]?.map((u) => (
                    <option key={u} value={u}>
                      {u}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          ) : (
            <div>
              <label className="block text-sm font-semibold text-blue-950 mb-2">
                Notes <span className="text-red-500">*</span>
              </label>
              <textarea
                placeholder="Write your diary notes..."
                value={form.notes}
                onChange={(e) => {
                  setForm((prev) => ({ ...prev, notes: e.target.value }));
                  e.target.style.height = "auto";
                  e.target.style.height = `${e.target.scrollHeight}px`;
                }}
                className="w-full min-h-32 rounded-xl border border-gray-300 bg-slate-50 px-5 py-4 focus:ring-4 focus:ring-blue-100 outline-none resize-none overflow-hidden transition"
                rows="4"
              />
            </div>
          )}

          {/* File Uploads */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-7">
            <div>
              <label className="block text-sm font-semibold text-blue-950 mb-3">
                Photos / Videos
              </label>
             <div className="flex items-center gap-4">    
              {/* Add Media Button */}
              <label className="flex-shrink-0 flex items-center justify-center w-40 h-14 bg-blue-100 text-blue-800 rounded-2xl font-bold text-sm cursor-pointer hover:bg-blue-200 transition active:scale-95">
                <FaPlus className="mr-2" /> Add Media
                <input
                  key={form.activePet + form.selectedCategory}
                  type="file"
                  multiple
                  accept="image/*,video/*"
                  className="hidden"
                  onChange={handleMediaChange}  // ✅ SAME FUNCTION
                />
              </label>
              {/* File Name + Delete */}
              {form.mediaFiles.length > 0 ? (
              <div className="flex flex-wrap items-center gap-2 flex-1 min-w-0"> 
              {/* Removed fixed bg from parent to allow individual file tags */}
              {form.mediaFiles.map((file, index) => (
                <div key={index} className="flex items-center gap-2 bg-gray-100 px-3 py-1.5 rounded-xl border border-gray-200">
                  <span className="text-sm font-medium text-blue-700 truncate max-w-[100px]">
                    {file.name}
                  </span>
                  <button
                    type="button"
                    onClick={() =>
                      setForm((prev) => ({
                        ...prev,
                        mediaFiles: prev.mediaFiles.filter((_, i) => i !== index),
                      }))
                    }
                    className="text-red-500 hover:bg-red-100 p-0.5 rounded-full"
                  >
                    <FaPlus className="rotate-45" size={12} />
                  </button>
                </div>
              ))}
            </div>
          ) : (
            <span className="text-sm text-gray-400 italic">No file chosen</span>
          )}
            </div>
          </div>       
            <div>
              <label className="block text-sm font-semibold text-blue-950 mb-3">
                Documents (PDF, DOC)
              </label>
             <div className="flex items-center gap-4">
    
                {/* Add Document Button */}
                <label className="flex-shrink-0 flex items-center justify-center w-40 h-14 bg-orange-100 text-orange-800 rounded-2xl font-bold text-sm cursor-pointer hover:bg-orange-200 transition active:scale-95">
                  <FaPlus className="mr-2" /> Add Document
                  <input
                    key={form.activePet + form.selectedCategory}
                    type="file"
                    multiple
                    accept=".pdf,.doc,.docx"
                    className="hidden"
                    onChange={handleDocChange}  // ✅ SAME FUNCTION
                  />
                </label>

                {/* File Name + Delete */}
                {form.docFiles.length > 0 ? (
                <div className="flex flex-wrap items-center gap-2 flex-1 min-w-0">
                {form.docFiles.map((file, index) => ( // ✅ Corrected from mediaFiles to docFiles
                  <div key={index} className="flex items-center gap-2 bg-orange-50 px-1 py-1.5 rounded-xl border border-orange-200">
                    <span className="text-sm font-medium text-blue-700 truncate max-w-[100px]">
                      {file.name}
                    </span>
                    <button
                      type="button"
                      onClick={() =>
                        setForm((prev) => ({
                          ...prev,
                          docFiles: prev.docFiles.filter((_, i) => i !== index),
                        }))
                      }
                      className="text-red-500 hover:bg-red-100 p-0.5 rounded-full"
                    >
                      <FaPlus className="rotate-45" size={12} />
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              <span className="text-sm text-gray-400 italic">No document chosen</span>
            )}
              </div>
            </div>
            </div>

          {/* Date & Time */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-semibold text-blue-950 mb-2">
                Date
              </label>
              <input
                type="date"
                value={form.date}
                onChange={(e) =>
                  setForm((prev) => ({ ...prev, date: e.target.value }))
                }
                className="w-full rounded-xl border border-gray-300 px-5 py-4 focus:ring-4 focus:ring-blue-100 outline-none"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-blue-950 mb-2">
                Time
              </label>
              <input
                type="time"
                value={form.time}
                onChange={(e) =>
                  setForm((prev) => ({ ...prev, time: e.target.value }))
                }
                className="w-full rounded-xl border border-gray-300 px-5 py-4 focus:ring-4 focus:ring-blue-100 outline-none"
              />
            </div>
          </div>

          {/* Visibility */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-4">
              Visibility
              <span className="ml-2 text-xs text-gray-500">
                (Public = visible to service provider)
              </span>
            </label>
            <div className="flex gap-4">
              {["Public", "Private"].map((v) => (
                <button
                  key={v}
                  onClick={() => setForm((prev) => ({ ...prev, type: v }))}
                  className={`flex-1 py-3.5 rounded-xl font-bold text-base transition shadow-md ${
                    form.type === v
                      ? "bg-orange-500 text-white"
                      : "bg-orange-100 text-orange-700 hover:bg-orange-200"
                  }`}
                >
                  {v}
                </button>
              ))}
            </div>
          </div>

          {/* Save Button */}
          <div className="pt-6 border-t border-gray-200">
            <button
              onClick={handleSave}
              //disabled={isSaveDisabled}
              className={`w-full py-4 rounded-xl font-bold text-lg transition shadow-lg ${
                isSaveDisabled
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-blue-950 text-white hover:bg-blue-900"
              }`}
            >
              Save Entry
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
